import { FormField } from "./rich-data.model";

/* eslint-disable @typescript-eslint/naming-convention */
export class ProfileModel {
  id: number;
  hotel_id: number;
  created_at: Date;
  updated_at: Date;
  first_name: string;
  middle_name: string;
  last_name: string;
  room_no: string;
  profile_pic_url: string;
  locale: string;
  timezone: number;
  gender: string;
  my_preferences: FormField[];
  entry_date: Date | string;
  release_date: Date | string;
  address: string;
  city: string;
  country: string;
  phone_country_id: string;
  phone_prefix_id: string;
  phone_no: string;
  mobile_country_id: string;
  mobile_prefix_id: string;
  mobile_no: string;
  voucher_or_booking_no: string;
  booking_date: Date;
  date_of_birth: Date | string;
  birth_place: string;
  nationality: string;
  travel_doc_type: string;
  reservation_pax: number;
  travel_doc_id: string;
  document_issued_on: Date;
  document_issued_in: string;
  e_mail: string;
  personal_data: boolean;
  privacy_policy: boolean;
  agent_name: string;
  id_no: string;
  wedding_anniversary: Date;
  allergy: boolean;
  allergy_description: string;
  vehicle_no: string;
  passport_front_image_url: string;
  passport_back_image_url: string;
  email_permission: boolean;
  invoice_info: boolean;
  company_name: string;
  invoice_id_no: string;
  tax_area: string;
  tax_no: string;
  company_address: string;
  invoice_mail: string;
  staff_name: string;
  arrival_hour: Date;
  guest_status: string;
  password: string;
  block_sms: boolean;
  block_email: boolean;
  only_newsletter: boolean;
  loyalty_card_id: number;
  loyalty_card_no: string;
  loyalty_card_family_id: number;
  loyalty_card_family_name: string;
  special_loyalty_member: boolean;
  loyalty_info: Loyaltyinfo;
  is_eligible_for_account: boolean;
  is_active: boolean;
  interest: string;
  privilege_card_no: string;
  post_code: string;
  birth_day: number;
  birth_month: number;
  anniversary_date: Date;
  signature: string;
  chat_badge: number;
  chat_badge_a: number;
  pillow_type: string;
  bed_type: string;
  room_type: string;
  newspaper: string;
  mattress_firmness: string;
  sleep_side: string;
  room_fragrance: string;
  terms_and_conditions: boolean;
  television_preferences: string;
  music_preferences: string;
  bathroom_amenities: string;
  accessibility_preferences: string;
  nutrition: string;
  bot_number: string;
  raincoat_need: boolean;
  others: string;
  centrifuge_token?: string;
  room_info: {
    building_id: number;
    area_id: number;
    block_id: number;
    floor_id: number;
    section_id: number;
  };


  constructor() {
    this.id = 0;
    this.hotel_id = 0;
    this.created_at = new Date();
    this.updated_at = new Date();
    this.first_name = '';
    this.middle_name = '';
    this.last_name = '';
    this.room_no = '';
    this.profile_pic_url = '';
    this.locale = '';
    this.timezone = 0;
    this.gender = '';
    this.entry_date = new Date();
    this.release_date = new Date();
    this.address = '';
    this.city = '';
    this.country = '';
    this.phone_country_id = '';
    this.phone_prefix_id = '';
    this.phone_no = null;
    this.mobile_country_id = '';
    this.mobile_prefix_id = '';
    this.mobile_no = '';
    this.voucher_or_booking_no = null;
    this.booking_date = new Date();
    this.date_of_birth = new Date();
    this.birth_place = '';
    this.nationality = '';
    this.travel_doc_type = '';
    this.travel_doc_id = '';
    this.document_issued_on = new Date();
    this.document_issued_in = '';
    this.e_mail = '';
    this.personal_data = true;
    this.privacy_policy = true;
    this.agent_name = '';
    this.id_no = '';
    this.wedding_anniversary = new Date();
    this.allergy = false;
    this.allergy_description = '';
    this.vehicle_no = '';
    this.passport_front_image_url = '';
    this.passport_back_image_url = '';
    this.email_permission = false;
    this.invoice_info = false;
    this.company_name = '';
    this.invoice_id_no = '';
    this.tax_area = '';
    this.tax_no = '';
    this.company_address = '';
    this.invoice_mail = '';
    this.staff_name = '';
    this.arrival_hour = new Date();
    this.guest_status = '';
    this.pillow_type = '';
    this.bed_type = '';
    this.room_type = '';
    this.newspaper = '';
    this.mattress_firmness = '';
    this.sleep_side = '';
    this.room_fragrance = '';
    this.television_preferences = '';
    this.music_preferences = '';
    this.bathroom_amenities = '';
    this.accessibility_preferences = '';
    this.nutrition = '';
    this.bot_number = '';
    this.raincoat_need = false;
    this.others = '';
  }
}

export interface Loyaltyinfo {
  points_earned: number;
  points_spend: number;
  remaining_point: number;
  overnight_stay: number;
  target_night_stay: number;
  earned_night_stay: number;
  room_type: string;
  menu_item_id: number;
}
